/* Sky Nutrition theme behaviour. No dependencies; runs alongside Dawn's global.js. */
(function () {
  'use strict';

  /* ---------- Money formatting (uses the shop's money format) ---------- */
  function formatMoney(cents, format) {
    cents = parseInt(cents, 10) || 0;
    format = format || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = (cents / 100).toFixed(2);
    var sep = function (num, thou, dec) {
      var parts = num.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    };
    var out = value;
    if (match) {
      switch (match[1]) {
        case 'amount_no_decimals': out = sep((cents / 100).toFixed(0), ',', '.'); break;
        case 'amount_with_comma_separator': out = sep(value, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = sep((cents / 100).toFixed(0), '.', ','); break;
        default: out = sep(value, ',', '.');
      }
      return format.replace(match[0], out);
    }
    return '$' + out;
  }

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sky-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sky-qty] [data-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-sky-qty]');
    var input = wrap.querySelector('input');
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.step, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page: variants, totals, gallery ---------- */
  function initPdp(root) {
    var fmt = root.dataset.moneyFormat;
    var qty = root.querySelector('[data-sky-qty-input]');
    var addBtn = root.querySelector('[data-sky-add]');
    var addLabel = root.querySelector('[data-sky-add-label]');
    var stage = root.querySelector('.sky-pdp__main');

    function current() {
      return root.querySelector('input[type="radio"][name="id"]:checked');
    }

    function unitPrice() {
      var r = current();
      if (r) return parseInt(r.dataset.price, 10);
      var p = root.querySelector('[data-sky-price]');
      return p ? parseInt(p.dataset.cents || 0, 10) : 0;
    }

    function setText(sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    }

    function showMedia(id) {
      if (!id || !stage) return;
      var thumb = root.querySelector('[data-sky-thumb][data-media-id="' + id + '"]');
      if (thumb) thumb.click();
    }

    function refresh() {
      var r = current();
      var available = true;
      if (r) {
        var price = parseInt(r.dataset.price, 10);
        var rrp = parseInt(r.dataset.rrp, 10) || 0;
        var margin = parseInt(r.dataset.margin, 10) || 0;
        available = r.dataset.available === 'true';
        setText('[data-sky-price]', formatMoney(price, fmt));
        var rrpWrap = root.querySelector('[data-sky-rrp]');
        if (rrpWrap) {
          rrpWrap.hidden = !(rrp > price);
          setText('[data-sky-rrp-value]', formatMoney(rrp, fmt));
        }
        var mWrap = root.querySelector('[data-sky-margin-wrap]');
        if (mWrap) {
          mWrap.hidden = !(margin > 0);
          setText('[data-sky-margin]', margin);
        }
        setText('[data-sky-sku]', r.dataset.sku || '–');
        setText('[data-sky-stock]', r.dataset.stock);
        showMedia(r.dataset.mediaId);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', r.value);
        window.history.replaceState({}, '', url.toString());
      }
      if (addBtn && addLabel) {
        var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
        if (available) {
          addBtn.removeAttribute('disabled');
          addLabel.textContent = 'Add to Order · ' + formatMoney(unitPrice() * q, fmt);
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addLabel.textContent = 'Out of stock';
        }
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[name="id"], [data-sky-qty-input]')) refresh();
    });
    if (qty) qty.addEventListener('input', refresh);

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sky-thumb]');
      if (!t || !stage) return;
      stage.src = t.dataset.src;
      stage.srcset = t.dataset.srcset;
      root.querySelectorAll('[data-sky-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === t); });
    });

    var back = root.querySelector('[data-sky-back]');
    if (back && document.referrer && document.referrer.indexOf(window.location.host) > -1) {
      back.addEventListener('click', function (e) { e.preventDefault(); window.history.back(); });
    }
  }

  /* ---------- Cart PO number: save as the buyer types so drawer re-renders keep it ---------- */
  var poTimer;
  document.addEventListener('input', function (e) {
    if (e.target.name !== 'attributes[PO Number]') return;
    clearTimeout(poTimer);
    var val = e.target.value;
    poTimer = setTimeout(function () {
      fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'PO Number': val } })
      }).catch(function () {});
    }, 400);
  });

  /* ---------- Close header dropdowns on outside click / Escape ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.sky-nav__drop[open], .sky-mobile[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.sky-nav__drop[open], .sky-mobile[open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  function init() {
    document.querySelectorAll('[data-sky-pdp]').forEach(initPdp);
    if (window.matchMedia('(max-width: 1023px)').matches) {
      document.querySelectorAll('.sky-filters[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
